import { memo } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { STATS_KEYS } from "@/constants/translations";

const HomeStats = memo(() => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-2">300+</div>
            <div className="text-gray-600">{t(STATS_KEYS.BOOKINGS)}</div>
          </div>

          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-2">1,000+</div>
            <div className="text-gray-600">{t(STATS_KEYS.HAPPY_GUESTS)}</div>
          </div>

          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-2">4.97</div>
            <div className="text-gray-600">{t(STATS_KEYS.AVERAGE_SCORE)}</div>
          </div>

          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-2">24/7</div>
            <div className="text-gray-600">{t(STATS_KEYS.SUPPORT)}</div>
          </div>
        </div>
      </div>
    </section>
  );
});

HomeStats.displayName = "HomeStats";

export default HomeStats;
